<h2 mat-dialog-title class="contact-dialog__title">
	{{ data.contact ? 'Edytuj osobę kontaktową' : 'Nowa osoba kontaktowa' }}
</h2>

<form [formGroup]="form" (ngSubmit)="submit()">
	<mat-dialog-content class="contact-dialog__content">
		<div class="row g-2">
			<div class="col-12 col-sm-6">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
					<mat-label>Imię</mat-label>
					<input matInput formControlName="firstName" autocomplete="off" />
					@if (fieldErrors()['firstName']; as error) {
						<mat-hint class="contact-dialog__error">{{ error }}</mat-hint>
					}
				</mat-form-field>
			</div>

			<div class="col-12 col-sm-6">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
					<mat-label>Nazwisko</mat-label>
					<input matInput formControlName="lastName" autocomplete="off" />
					@if (fieldErrors()['lastName']; as error) {
						<mat-hint class="contact-dialog__error">{{ error }}</mat-hint>
					}
				</mat-form-field>
			</div>

			<div class="col-12">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
					<mat-label>Stanowisko</mat-label>
					<input matInput formControlName="position" autocomplete="off" />
					@if (fieldErrors()['position']; as error) {
						<mat-hint class="contact-dialog__error">{{ error }}</mat-hint>
					}
				</mat-form-field>
			</div>

			<div class="col-12 col-sm-6">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
					<mat-label>E-mail</mat-label>
					<input matInput type="email" formControlName="email" autocomplete="off" />
					@if (form.controls.email.hasError('email')) {
						<mat-error>Nieprawidłowy adres e-mail</mat-error>
					}
					@if (fieldErrors()['email']; as error) {
						<mat-hint class="contact-dialog__error">{{ error }}</mat-hint>
					}
				</mat-form-field>
			</div>

			<div class="col-12 col-sm-6">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
					<mat-label>Telefon</mat-label>
					<input matInput type="tel" formControlName="phone" autocomplete="off" />
					@if (fieldErrors()['phone']; as error) {
						<mat-hint class="contact-dialog__error">{{ error }}</mat-hint>
					}
				</mat-form-field>
			</div>

			<div class="col-12">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
					<mat-label>Dział (opcjonalnie)</mat-label>
					<mat-select formControlName="department">
						<mat-option [value]="null">— bez działu —</mat-option>
						@for (department of data.departments; track department.id) {
							<mat-option [value]="department.id">{{ department.name }}</mat-option>
						}
					</mat-select>
					@if (fieldErrors()['department']; as error) {
						<mat-hint class="contact-dialog__error">{{ error }}</mat-hint>
					}
				</mat-form-field>
			</div>

			<div class="col-12">
				@if (form.hasError('contactRequired') && form.touched) {
					<p class="contact-dialog__hint contact-dialog__hint--error mb-0">
						Podaj przynajmniej imię, nazwisko, e-mail albo telefon.
					</p>
				} @else if (generalError()) {
					<p class="contact-dialog__hint contact-dialog__hint--error mb-0">{{ generalError() }}</p>
				} @else {
					<p class="contact-dialog__hint mb-0">
						Wymagane jest co najmniej jedno z: imię, nazwisko, e-mail, telefon.
					</p>
				}
			</div>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="contact-dialog__actions" align="end">
		<button mat-button type="button" mat-dialog-close [disabled]="isSaving()">Anuluj</button>
		<button mat-raised-button color="primary" type="submit" [disabled]="isSaving()">
			{{ isSaving() ? 'Zapisywanie…' : 'Zapisz' }}
		</button>
	</mat-dialog-actions>
</form>
